import React from 'react';
import ReactDOM from "react-dom";
import App from './components/app';
import { Provider } from 'react-redux';
import { ApolloProvider } from "react-apollo";
import { createStore, applyMiddleware, compose } from 'redux';
import client from "./lib/apolloClient";
import reduxThunk from 'redux-thunk';
import reducers from './reducers';
require('./styles');


//////////////////////////////////////
// Setup redux
//////////////////////////////////////
const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

const enchancer = composeEnhancers(
  applyMiddleware(
    reduxThunk
  )
)

export const store = createStore(reducers, enchancer);
//////////////////////////////////////


//////////////////////////////////////
// Initialise App;
//////////////////////////////////////
ReactDOM.render(
    <ApolloProvider client={client}>
    <Provider store={store}>
        <App />
    </Provider>
    </ApolloProvider>,
  document.getElementById('ap-search-widget')
);
//////////////////////////////////////
